// Aviso ligero entre pantallas del mismo evento, sin pasar por Redux: Subir fotos y Fotos lo
// emiten al terminar una subida o un borrado, y la cabecera lo escucha para refrescar el
// recuento de fotos (y con él el botón «Terminar subida y activar selfies») sin tener que cambiar de pestaña.
export const PHOTOS_CHANGED = 'revopic:photos-changed';

export const notifyPhotosChanged = (eventId) => {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(new CustomEvent(PHOTOS_CHANGED, { detail: { eventId } }));
};

// Devuelve la función para dejar de escuchar. Sin eventId escucha todos los eventos.
export const onPhotosChanged = (eventId, handler) => {
    const listener = (e) => { if (!eventId || e.detail?.eventId === eventId) handler(); };
    window.addEventListener(PHOTOS_CHANGED, listener);
    return () => window.removeEventListener(PHOTOS_CHANGED, listener);
};
